export const searchMixin = {
	data() {
		return {
			search: {
				name: "",
				abook_types: [ 1, 2 ],
				show_columns: [],
				sort_columns: [ 'code' ],
			}			
		}
	},
	methods: {
		reset_search() {
			this.search.name = "";
			this.search.abook_types = [ 1, 2 ];
			this.search.show_columns = [];
			this.search.sort_columns = [ 'code' ];
		},		
		parse_search(search_json) {
			this.reset_search();

			let parsed_search = JSON.parse(search_json);

			if (parsed_search.hasOwnProperty('name')) { this.search.name = parsed_search.name };
			if (parsed_search.hasOwnProperty('abook_types')) { this.search.abook_types = parsed_search.abook_types };
			if (parsed_search.hasOwnProperty('show_columns')) { this.search.show_columns = parsed_search.show_columns };
			if (parsed_search.hasOwnProperty('sort_columns')) { this.search.sort_columns = parsed_search.sort_columns };
		},	
	}
}